import { render, staticRenderFns } from "./AddOrEditItemDialog.vue?vue&type=template&id=62a038c0"
import script from "./AddOrEditItemDialog.vue?vue&type=script&lang=js"
export * from "./AddOrEditItemDialog.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditItemDialog.vue?vue&type=style&index=0&id=62a038c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports